/**
* Fromalization of our icon sizes into a type
*/
export type IconSize = 14 | 16 | 20 | 30;

export interface SizeMap {
	[key: string]: IconSize;
}
